const serviceWorkerUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

const serviceWorkerRegistration = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        // Use ES Module version of our Service Worker in development
        if (process.env.NODE_ENV === 'development') {
          await navigator.serviceWorker.register(serviceWorkerUrl, { type: 'module' });
        } else {
          // In production, use the normal service worker registration
          await navigator.serviceWorker.register(serviceWorkerUrl);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Service worker registration failed: ', err);
      }
    });
  }
};

export default serviceWorkerRegistration;
